import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SlackLogo } from '../../../../components';
import { Button, ButtonText } from './AddToSlackButton.styles';
export function AddToSlackButton({ text, onClick }) {
    return (_jsxs(Button, Object.assign({ onClick: onClick, "data-testid": "addToSlackButton" }, { children: [_jsx(SlackLogo, {}, void 0), _jsx(ButtonText, { document: text }, void 0)] }), void 0));
}
//# sourceMappingURL=AddToSlackButton.js.map